var map = {
	"./cash-white": 8,
	"./cash-white.png": 8,
	"./checkbox-filled-in": 9,
	"./checkbox-filled-in.png": 9,
	"./custom-select": 10,
	"./custom-select.png": 10,
	"./favicon": 5,
	"./favicon.ico": 181,
	"./favicon.png": 5,
	"./glg-premium": 11,
	"./glg-premium.png": 11,
	"./golf-background": 12,
	"./golf-background.jpg": 12,
	"./icon/danger": 13,
	"./icon/danger.svg": 13,
	"./icon/four_player_scramble": 14,
	"./icon/four_player_scramble.png": 14,
	"./icon/individual_stableford": 15,
	"./icon/individual_stableford.png": 15,
	"./icon/success": 16,
	"./icon/success.svg": 16,
	"./icon/two_player_bestball": 17,
	"./icon/two_player_bestball.png": 17,
	"./icon/warning": 18,
	"./icon/warning.svg": 18,
	"./logo-black": 19,
	"./logo-black.png": 19,
	"./logo-branding": 20,
	"./logo-branding.png": 20,
	"./logo-icon": 21,
	"./logo-icon.png": 21,
	"./logo-outings-blue": 22,
	"./logo-outings-blue.png": 22,
	"./logo-outings-text": 23,
	"./logo-outings-text.png": 23,
	"./logo-text": 24,
	"./logo-text.png": 24,
	"./logo-white": 25,
	"./logo-white.png": 25,
	"./xleague-branding": 26,
	"./xleague-branding.png": 26,
	"./xleague_logo": 27,
	"./xleague_logo.png": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;